import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import useIntervalDescription from "@src/modules/DeviceStatus/Devices/DeviceInfoView/DeviceInfoSidebar/Tests/hooks/useIntervalDescription";
import {
  BenchmarkTag,
  IntervalText,
  TestName,
  TileWrapper,
} from "@src/modules/shared/components/TestTile/TestTile.components";
import { StudyTestResult } from "@src/modules/shared/types";

interface Props {
  test: StudyTestResult;
  isActive: boolean;
  onClick: (test: StudyTestResult) => void;
}

const TestTile: FunctionComponent<Props> = ({ test, isActive, onClick }) => {
  const { getDescription } = useIntervalDescription();
  const { t } = useTranslation();

  return (
    <TileWrapper
      key={test.id}
      status={test.resultStatus}
      isActive={isActive}
      onClick={() => onClick(test)}
    >
      <TestName>{test.name}</TestName>
      {!test.isCustomTest && (
        <IntervalText>{`(${getDescription(test.daysInterval)})`}</IntervalText>
      )}
      {test.isBaseTest && <BenchmarkTag>{t("Benchmark")}</BenchmarkTag>}
    </TileWrapper>
  );
};

export default TestTile;
